export const OUR_MATERIAL = [
    {
      item: 'Acrylic',
      itemImageDesktop: '/images/ourMaterial/desktop/acrylic.webp',
      itemImageMobile: '/images/ourMaterial/mobile/acrylic.webp',
      path: "/our-materials/acrylic",
    },
    {
      item: 'Elastic',
      itemImageDesktop: '/images/ourMaterial/desktop/elastic.webp',
      itemImageMobile: '/images/ourMaterial/mobile/elastic.webp',
      path: "/our-materials/elastic",
    },
    {
      item: "Fabric",
      itemImageDesktop: "/images/ourMaterial/desktop/fabric.webp",
      itemImageMobile: "/images/ourMaterial/mobile/fabric.webp",
      path: "/our-materials/fabric",
    },
    {
      item: "Leather",
      itemImageDesktop: "/images/ourMaterial/desktop/leather.webp",
      itemImageMobile: "/images/ourMaterial/mobile/leather.webp",
      path: "/our-materials/leather",
    },
    {
      item: "MDF",
      itemImageDesktop: "/images/ourMaterial/desktop/MDF.webp",
      itemImageMobile: "/images/ourMaterial/mobile/MDF.webp",
      path: "/our-materials/medium-density-fiberboard(MDF)",
    },
    {
      item: "Paper",
      itemImageDesktop: "/images/ourMaterial/desktop/paper.webp",
      itemImageMobile: "/images/ourMaterial/mobile/paper.webp",
      path: "/our-materials/paper",
    },
    {
      item: "PU",
      itemImageDesktop: "/images/ourMaterial/desktop/pu.webp",
      itemImageMobile: "/images/ourMaterial/mobile/pu.webp",
      path: "/our-materials/PU",
    },
    {
      item: "Push Lock",
      itemImageDesktop: "/images/ourMaterial/desktop/pushlock.webp",
      itemImageMobile: "/images/ourMaterial/mobile/pushlock.webp",
      path: "/our-materials/push-lock",
    },
    {
      item: "Rod",
      itemImageDesktop: "/images/ourMaterial/desktop/rod.webp",
      itemImageMobile: "/images/ourMaterial/mobile/rod.webp",
      path: "/our-materials/rod",
    },
    {
      item: "Ribbon",
      itemImageDesktop: "/images/ourMaterial/desktop/ribbon.webp",
      itemImageMobile: "/images/ourMaterial/mobile/ribbon.webp",
      path: "/our-materials/ribbon",
    },
    {
      item: "Snap Button",
      itemImageDesktop: "/images/ourMaterial/desktop/snapbotton.webp",
      itemImageMobile: "/images/ourMaterial/mobile/snapbotton.webp",
      path: "/our-materials/snap-button",
    },
    {
      item: "Stainless",
      itemImageDesktop: "/images/ourMaterial/desktop/stainless.webp",
      itemImageMobile: "/images/ourMaterial/mobile/stainless.webp",
      path: "/our-materials/stainless",
    },
    {
      item: "Steel",
      itemImageDesktop: "/images/ourMaterial/desktop/steel.webp",
      itemImageMobile: "/images/ourMaterial/mobile/steel.webp",
      path: "/our-materials/steel",
    },
    {
      item: "Velvet",
      itemImageDesktop: "/images/ourMaterial/desktop/velvet.webp",
      itemImageMobile: "/images/ourMaterial/mobile/velvet.webp",
      path: "/our-materials/velvet",
    },
    {
      item: "Wood",
      itemImageDesktop: "/images/ourMaterial/desktop/wood.webp",
      itemImageMobile: "/images/ourMaterial/mobile/wood.webp",
      path: '/our-materials/wood',
    },
    {
      item: "Metal Tin",
      itemImageDesktop: "/images/ourMaterial/desktop/metal_tin.webp",
      itemImageMobile: "/images/ourMaterial/mobile/metal_tin.webp",
      path: '/our-materials/metal-tin',
    }
  ]